export default __webpack_public_path__ + "static/esatto-favicon-white-42b2b2764bf5b70b5f2ae7cf50d5df3b.png";